import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Newfooter from "../NewFooter/Newfooter";
import {
  Box,
  Container,
  Typography,
  Paper,
  CircularProgress,
  Grid,
  Collapse
} from "@mui/material";
import WarningIconImg from "../../images/warning1.jpg"; 

import { 
  VIPSDataServiceURL, 
  requestOptions 
} from '../../Constants/GlobalConstant';

const CONFIG = {
  BASE_URL: VIPSDataServiceURL.replace(/\/$/, ""),
  ENDPOINTS: {
    CUSTOM_MSG: '/User/GetCustomMessage',
    SYSTEM_PARAM: '/Misc/GetSystemParameterValueByName'
  },
  PARAMS: {
    WELCOME_MSG_NAME: 'HomeLogin_Message' 
  },
  COLORS: {
    ERROR: '#d32f2f',        
    ERROR_BG: '#fff4f4',    
    ERROR_BORDER: '#ffcdd2',
    TITLE_RED: '#d32f2f',   
    BG_MAIN: '#f0f2f5',
    TEXT_MAIN: '#333'
  }
};

const Home = () => { 
  const navigate = useNavigate();

  const userPost = useSelector((state) => state.user);

  const loggedInUserId = userPost?.paxWebSessionStrings?.find(
    (item) => item.Key === 'user_id'
  )?.Value || '';

  const divisionNameFromStore = userPost?.paxWebSessionStrings?.find(
    (item) => item.Key === 'DivDesc' || item.Key === 'divisionDescription'
  )?.Value;

  const [divisionName, setDivisionName] = useState(divisionNameFromStore || "Paxar");
  const [customMessages, setCustomMessages] = useState([]);
  const [welcomeBody, setWelcomeBody] = useState([]); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (divisionNameFromStore) {
        setDivisionName(divisionNameFromStore);
    }

    if (!loggedInUserId) {
        setLoading(false);
        return; 
    }

    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      setLoading(true);
      const headers = { ...requestOptions.headers, 'Content-Type': 'application/json' };

      const msgPromise = axios.post(
          `${CONFIG.BASE_URL}${CONFIG.ENDPOINTS.CUSTOM_MSG}?${new URLSearchParams({ userId: '""' })}`, 
          null, 
          { headers, signal }
      );

      const welcomePromise = axios.post(
          `${CONFIG.BASE_URL}${CONFIG.ENDPOINTS.SYSTEM_PARAM}`, 
          {}, 
          { 
              params: { name: CONFIG.PARAMS.WELCOME_MSG_NAME }, 
              headers,
              signal 
          }
      );

      try {
        const [msgRes, paramRes] = await Promise.all([msgPromise, welcomePromise]);

        if (Array.isArray(msgRes.data) && msgRes.data.length > 0) {
            let rawHtml = msgRes.data[0];
            const parts = rawHtml.split(/<br\s*\/?>/i);
            const cleanedParts = parts.map(part => {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = part;
                return (tempDiv.textContent || tempDiv.innerText || "").trim();
            }).filter(text => text.length > 0);
            setCustomMessages(cleanedParts);
        }

        if (paramRes.data && Array.isArray(paramRes.data.welcomeMessage)) {
            setWelcomeBody(paramRes.data.welcomeMessage);
        } else {
            setWelcomeBody(["Error in api"]);
        }

      } catch (err) {
        if (!axios.isCancel(err)) {
            console.error("Home Data Fetch Error:", err);
            setWelcomeBody(["Unable to load welcome message."]);
        }
      } finally {
        if (!signal.aborted) setLoading(false);
      }
    };

    fetchData();

    return () => controller.abort();

  }, [loggedInUserId, divisionNameFromStore]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: CONFIG.COLORS.BG_MAIN }}>
      <Box component="main" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', pt: 6, pb: 8 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} md={10}>
                <Paper elevation={6} sx={{ p: { xs: 3, md: 5 }, borderRadius: 4, position: 'relative', minHeight: '400px' }}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                            <CircularProgress sx={{ color: CONFIG.COLORS.TITLE_RED }} />
                        </Box>
                    ) : (
                        <>
                            <Box sx={{ mb: 4, textAlign: 'left' }}>
                                <Typography variant="h4" sx={{ fontWeight: 700, color: CONFIG.COLORS.TITLE_RED, mb: 1 }}>
                                    Home Page
                                </Typography>
                                <Typography variant="h6" sx={{ color: CONFIG.COLORS.TITLE_RED, fontWeight: 400 }}>
                                    Welcome to the {divisionName} Home Page
                                </Typography>
                            </Box>

                            <Collapse in={customMessages.length > 0}>
                                <Box sx={{ mb: 4, p: 2, bgcolor: CONFIG.COLORS.ERROR_BG, borderRadius: 2, border: `1px dashed ${CONFIG.COLORS.ERROR_BORDER}` }}>
                                    {customMessages.map((msg, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: index < customMessages.length - 1 ? 1.5 : 0, textAlign: 'left' }}>
                                            
                                            {/* 2. Custom Image Implementation */}
                                            <Box 
                                                component="img"
                                                src={WarningIconImg}
                                                alt="Warning"
                                                sx={{ 
                                                    width: 24, // Adjusted to standard icon size
                                                    height: 24, 
                                                    mt: 0.3, 
                                                    objectFit: 'contain'
                                                }} 
                                            />

                                            <Typography variant="body1" sx={{ color: CONFIG.COLORS.ERROR, fontWeight: 700 }}>
                                                {msg}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Collapse>

                            <Box sx={{ color: '#444', lineHeight: 1.8, fontSize: '1.05rem', textAlign: 'left' }}>
                                {welcomeBody.map((paragraph, index) => (
                                    <Typography key={index} paragraph>{paragraph}</Typography>
                                ))}
                            </Box>
                        </>
                    )}
                </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Newfooter />
    </Box>
  );
};

export default Home;